var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":_vm.clicked}},[(_vm.icon != null && _vm.icon !== '')?_c('i',{class:'fas fa-' + _vm.icon}):_vm._e(),_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }